import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import cloneDeep from "lodash/cloneDeep";
import { useSessionStorageState } from "ahooks";

import { fetchMenus, MenuItem, fetchUserInfo } from "@services/common";
import routes from "@configs/page-routes";

export type Data = RouteItem & { children?: RouteItem[]; routes?: any[] };
export type RouteItem = {
  path: string;
  element?: any;
  hideInMenu?: boolean;
  name?: string;
  icon?: any;
  component?: any;
  access?: string;
};

const formatHide = (data: any[], access: string[]) => {
  data.forEach((item) => {
    if (item.access && !access.includes(item.access)) {
      item.hideInMenu = true;
    }

    if (Array.isArray(item.children)) {
      formatHide(item.children, access);
    }
  });
};

const initAccess = (access: string[], data: MenuItem[]) => {
  data?.forEach((item) => {
    if (item.menu_type === "M") {
      access.push(item.menu_key);
    } else {
      access.push(item.operation_key);
    }

    if (Array.isArray(item.menus)) {
      initAccess(access, item.menus);
    }
  });

  return access;
};

const getAccess = (menus: MenuItem[]) => {
  const access: string[] = [];
  initAccess(access, menus);
  return access;
};

const findCurrentRoute = (routes: Data[], pathname: string) => {
  const data = [...routes];
  for (let i = 0; i < data?.length; i++) {
    const item = data[i];

    if (item?.path === pathname) {
      return item;
    }

    if (Array.isArray(item?.children)) {
      data.push(...item.children);
    }
  }
};

export default () => {
  const location = useLocation();

  // const [access, setAccess] = useState<string[]>([]);
  const [access, setAccess] = useSessionStorageState<string[]>("access", {
    defaultValue: undefined,
  });
  const [isPermission, setIsPermission] = useState(true);

  const getMenus = async () => {
    const ret = await fetchMenus().catch((err) => console.log(err));

    if (!ret?.result) return;

    const userInfoRet = await fetchUserInfo().catch((err) => console.log(err));

    if (userInfoRet?.object?.currentVendor == 0) {
      setAccess(["vendor-profile", "vendor-page-vendor-details"]);
      return;
    }

    const access = getAccess(ret?.object || []) || [];
    setAccess(access);
  };

  const getMenuRoutes = (data: Data[], access: string[]) => {
    if (!access?.length) return { path: "/", routes: [] };

    const menus = cloneDeep(data);
    formatHide(menus, access);

    return { path: "/", routes: menus };
  };

  const getPermission = (currentRoute: Data | undefined, access: string[]) => {
    if (currentRoute === undefined) return true;
    if (currentRoute.access === undefined) return true;
    return access.includes(currentRoute?.access);
  };

  useEffect(() => {
    if (!access) return;

    const currentRoute = findCurrentRoute(routes, location?.pathname);
    const isPermission = getPermission(currentRoute, access);
    setIsPermission(isPermission);
  }, [location, access]);

  useEffect(() => {
    getMenus();
  }, []);

  return { isPermission, access, getMenuRoutes };
};
